import type { FC } from 'react'

import { Container } from '@skytech/ui/Container'

import { useAppContext } from '@/app/index.context'
import { Translation } from '@/app/translations/Translation'

const Showcase: FC = () => {
  const { locale, setLocale } = useAppContext()

  return (
    <Container className="showcase">
      <button onClick={() => setLocale(locale === 'en' ? 'no' : 'en')}>change language</button>
      <hr />
      <Translation id="test" />
    </Container>
  )
}

export default Showcase
